import Component from "@glimmer/component";
import { and } from "discourse/truth-helpers";
import dReplaceEmoji from "discourse/ui-kit/helpers/d-replace-emoji";
import { i18n } from "discourse-i18n";

const TRUNCATE_LENGTH_LIMIT = 85;

export default class TopicMapLink extends Component {
  get linkClasses() {
    return this.args.attachment
      ? "topic-link track-link attachment"
      : "topic-link track-link";
  }

  get truncatedContent() {
    const content = this.args.title || this.args.url;
    return content.length > TRUNCATE_LENGTH_LIMIT
      ? `${content.slice(0, TRUNCATE_LENGTH_LIMIT).trim()}...`
      : content;
  }

  <template>
    <a
      aria-label={{i18n "topic_map.clicks" count=@clickCount}}
      class={{this.linkClasses}}
      data-clicks={{@clickCount}}
      data-ignore-post-id="true"
      data-user-id={{@userId}}
      href={{@url}}
      rel="nofollow ugc noopener noreferrer"
      target="_blank"
      title={{@url}}
    >
      <span class="content">
        {{#if @title}}
          {{dReplaceEmoji this.truncatedContent}}
        {{else}}
          {{this.truncatedContent}}
        {{/if}}
      </span>
    </a>
    {{#if (and @title @rootDomain)}}
      <span class="domain">
        {{@rootDomain}}
      </span>
    {{/if}}
  </template>
}
